import React, { useCallback, useState } from "react";

import { Col, Row } from "react-bootstrap";

import awards from "@/data/awards";

import i18n from "../i18n";
import styles from "../styles/Awards.module.css";

import type { IAward } from "@/interfaces/IAward";

const AwardsComponent = (): React.JSX.Element => {
  const { t, language } = i18n;
  // Clicking a card is the only thing that flips it: every card keeps its own
  // state, so any number of them can stay flipped until clicked again.
  const [flippedIds, setFlippedIds] = useState<ReadonlySet<string>>(
    () => new Set<string>(),
  );

  const toggleFlipped = useCallback((id: string) => {
    setFlippedIds((previous: ReadonlySet<string>) => {
      const next = new Set(previous);

      if (!next.delete(id)) {
        next.add(id);
      }

      return next;
    });
  }, []);

  return (
    <Row className={`justify-content-center ${styles.grid}`}>
      {awards.map((award: IAward) => {
        const isFlipped = flippedIds.has(award.id);

        return (
          <Col key={award.id} className="mb-4" lg={3} md={4} sm={6} xs={12}>
            <button
              aria-pressed={isFlipped}
              className={`${styles.flipCard} ${isFlipped ? styles.isFlipped : ""}`}
              onClick={() => toggleFlipped(award.id)}
              type="button"
            >
              <span className={styles.flipCardInner}>
                <span className={styles.flipCardFront}>
                  <img
                    alt={award.event}
                    className={styles.trophy}
                    loading="lazy"
                    src="/images/faTrophy.png"
                    width={400}
                  />
                  <span className={styles.event}>{t(award.event)}</span>
                  {/* Nothing else signals the card turns over; aria-hidden
                      because aria-pressed already carries that for assistive
                      tech, and the button's name should stay the event. */}
                  <span aria-hidden="true" className={styles.hint}>
                    {t("see_more")}
                  </span>
                </span>
                <span className={styles.flipCardBack}>
                  <span className={styles.date}>
                    {award.date.toLocaleDateString(language, {
                      year: "numeric",
                      month: "long",
                    })}
                  </span>
                  <span className={styles.title}>{t(award.title)}</span>
                  <span className={styles.event}>{t(award.event)}</span>
                  <span className={styles.location}>{t(award.location)}</span>
                </span>
              </span>
            </button>
          </Col>
        );
      })}
    </Row>
  );
};

export default AwardsComponent;
